export default __webpack_public_path__ + "media/images/favicon-25ded6b66a2e24da863be0344d8aa738.png";